import React, {createContext, useCallback, useContext, useEffect, useState} from "react";
import {SiteDataType, useGetSiteDataQuery} from "../generated/graphql";

const SiteDataContext = createContext<any|null>(null);

type SiteDataPagesValue = {
    [key:string]:any
};

type SiteDataContextValue = {
    siteData?: SiteDataType|null
    pages:SiteDataPagesValue,
    setSite:(value:string)=>void,
    setInternal:(value:boolean)=>void
};



export function useSiteDataContext():SiteDataContextValue {
    return useContext<SiteDataContextValue>(SiteDataContext);
}

type TextContextProps = React.PropsWithChildren<{}>;


export function SiteDataContextProvider({children}: TextContextProps) {
    const [site,_setSite] = useState(()=>{
        let newSite = window.localStorage.getItem('site');
        if(newSite) {
            return JSON.parse(newSite);
        }
        return document.location.hostname;
    });
    const [internal,_setInternal] = useState(()=>{
        let newSite = window.localStorage.getItem('internal');
        if(newSite) {
            return JSON.parse(newSite);
        }
        return false;
    });
    const setSite = useCallback((v:string)=>{
        window.localStorage.setItem('site',JSON.stringify(v));
        _setSite(v);
    },[]);
    const setInternal = useCallback((v:boolean)=>{
        window.localStorage.setItem('internal',JSON.stringify(v));
        _setInternal(v);
    },[]);
    const [settings,setSettings] = useState<SiteDataContextValue>({
        pages: {},
        setSite:setSite,
        setInternal:setInternal
    });
    useEffect(()=>{
        if(!site) {
            var newSite = window.localStorage.getItem('site');
            try {
                if (newSite) {
                    console.log('ns is', newSite);
                    _setSite(JSON.parse(newSite));
                } else {
                    _setSite(document.location.hostname);
                }
            } catch(e) {

            }
        }
    },[]);
    const [settingsQuery] = useGetSiteDataQuery({ pause:!site,variables:{site:site,internal:internal}});
    useEffect(()=>{
        if(settingsQuery.fetching ||settingsQuery.error) return;
        setSettings((old)=>{
            let newSettings = {...old};
            newSettings.siteData = settingsQuery.data?.siteData;
            settingsQuery.data?.siteData?.pages?.forEach((page)=> {
                newSettings.pages[page?.name!] = {};
                page?.values?.forEach((value)=>{
                    newSettings.pages[page?.name!][value?.name!] = value?.value!;
                });
            });
            return newSettings;
        })
    },[settingsQuery.data]);
    return<SiteDataContext.Provider value={settings}>
            {children}
    </SiteDataContext.Provider>
}